/*
import React from "react"
import { Navigate } from "react-router-dom"

const Authmiddleware = props => {
  if (!localStorage.getItem("authUser")) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    )
  }
  return <React.Fragment>{props.children}</React.Fragment>
}

export default Authmiddleware
*/

import React from "react"
import { Navigate } from "react-router-dom"
import { isTokenValid } from "../../utils/auth" // Asegúrate de importar la función isTokenValid

const Authmiddleware = props => {
  if (!localStorage.getItem("authUser") || !isTokenValid()) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    )
  }
  return <React.Fragment>{props.children}</React.Fragment>
}

export default Authmiddleware
